import React from 'react';
import { Link } from 'react-router-dom';

import { HeroSection } from '../Hero/HeroSection';
import { HowItWorks } from './HowItWorkSection';
import { CryptoGuide } from './CryptoGuideSection';
import { SuccessStories } from './SucessStoriesSection';
import { heroBg } from '../../assets';

const CTAFooter = () => {
  return (
    <section className="w-full bg-gradient-to-r from-[#0CB4FC] to-[#D24CFE] text-white py-10 sm:py-16 px-4 sm:px-6 rounded-lg mx-0 sm:mx-4">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 sm:mb-4">Transform Your Fund Management Today</h2>
        <p className="text-base sm:text-lg md:text-xl mb-6 sm:mb-8">Join forward-thinking fund managers already leveraging tokenization for better fundraising and operations.</p>
        <Link to="/sales/create-fund">
          <button className="bg-white text-[#0CB4FC] font-semibold py-2 sm:py-3 px-6 sm:px-8 rounded-md hover:bg-opacity-90 transition-all shadow-md">
            Schedule a Demo
          </button>
        </Link>
      </div>
    </section>
  );
};
const HomeContent = () => {
  return (
    <section className="flex flex-col gap-16 sm:gap-24 md:gap-32 whitespace-pre-wrap">
      <HeroSection
        title="Transforming Venture Capital"
        backgroundImage={heroBg}
      />
      <HowItWorks />
      <CryptoGuide />
      <SuccessStories />
      <CTAFooter />
    </section>
  );
};

export default HomeContent;
